export const getFontFaceStyles = () => /* scss */ `
    /* JDSansPro - Medium */
    @font-face {
        font-family: 'JDSansPro-Medium';
        font-style: normal;
        font-weight: normal;
        src: url('https://cdn.ux.deere.com/brand-foundations/1.3.1/typography/JDSansPro-Medium.woff2') format('woff2'),
            url('https://cdn.ux.deere.com/brand-foundations/1.3.1/typography/JDSansPro-Medium.woff') format('woff')
    }
`;
